<article>
  <header>
    <div class="tenant-logo-wrapper">
      <img
        [src]="(tenantLogoUrl | authImage) ?? defaultTenantLogoUrl"
        alt="Tenant Logo"
      />
    </div>

    <div class="flex-fill">
      <div class="d-flex flex-column">
        <span id="tenant-client-name">{{ tenant.clientName }}</span>
        <span id="tenant-id" [oaiboxCopy]="tenant.id">{{ tenant.id }}</span>
      </div>
      <div class="under-label">{{ tenant.clientDescription }}</div>
    </div>

    <span id="last-update-date">
      Last Update:
      {{
        (tenant.updatedAt != null ? tenant.updatedAt : tenant.createdAt)
          | date: "dd/MM/yyy HH:mm"
      }}
    </span>
  </header>

  <section class="d-flex flex-wrap justify-content-around g-g mb-g">
    <div class="d-flex flex-column">
      <span class="pills-list-title">Fronthaul Type</span>
      <ul class="pills">
        @for (type of tenant.availableFronthaulTypes; track $index) {
          <li class="pill">
            {{ (type | fronthaulConfig)?.label }}
          </li>
        }
      </ul>
    </div>

    <div class="d-flex flex-column">
      <span class="pills-list-title">Frequency Range</span>
      <ul class="pills">
        @for (range of tenant.availableFrequencyRanges; track $index) {
          <li class="pill">
            {{ range }}
          </li>
        }
      </ul>
    </div>

    <div class="d-flex flex-column">
      <span class="pills-list-title">Duplex Mode</span>
      <ul class="pills">
        @for (mode of tenant.availableDuplexModes; track $index) {
          <li class="pill">
            {{ mode }}
          </li>
        }
      </ul>
    </div>
  </section>

  <div class="h-divider"></div>

  <section class="licensing-configuration">
    <div>
      <div class="pills flex-column">
        <div class="pill" [ngClass]="tenant.education ? 'active' : 'inactive'">
          Education
        </div>
        <div
          class="pill"
          [ngClass]="tenant.kubernetes ? 'active' : 'inactive'"
        >
          Kubernetes
        </div>
        <div
          class="pill"
          [ngClass]="tenant.advancedMode ? 'active' : 'inactive'"
        >
          Advanced Mode
        </div>
      </div>
    </div>

    <div>
      <span class="fw-bold">Premium Features</span>

      <div class="pills">
        <div class="pill" [ngClass]="tenant.handover ? 'active' : 'inactive'">
          Mobility
        </div>
        <div class="pill" [ngClass]="tenant.qosium ? 'active' : 'inactive'">
          Qosium
        </div>
        <div class="pill" [ngClass]="tenant.ris ? 'active' : 'inactive'">
          RIS
        </div>
        <div class="pill" [ngClass]="tenant.multiRan ? 'active' : 'inactive'">
          Multi-RAN
        </div>
        <div class="pill" [ngClass]="tenant.redCap ? 'active' : 'inactive'">
          RedCap
        </div>
        <div
          class="pill"
          [ngClass]="tenant.offline?.enable ? 'active' : 'inactive'"
        >
          Offline
        </div>
      </div>
    </div>

    <div>
      <span class="fw-bold">Features</span>

      <div class="pills">
        <div class="pill" [ngClass]="tenant.flexRic ? 'active' : 'inactive'">
          FlexRIC
        </div>
        <div
          class="pill"
          [ngClass]="tenant.ueManagement ? 'active' : 'inactive'"
        >
          UE Management
        </div>
        <div class="pill" [ngClass]="tenant.slicing ? 'active' : 'inactive'">
          Network Slicing
        </div>
      </div>
    </div>

    <div>
      <span class="fw-bold">Use Cases Library</span>

      <div class="pills">
        <div
          class="pill"
          [ngClass]="tenant.digitalTwin ? 'active' : 'inactive'"
        >
          Digital Twin
        </div>
        <div class="pill" [ngClass]="tenant.isac ? 'active' : 'inactive'">
          ISAC
        </div>
        <div
          class="pill"
          [ngClass]="tenant.radarDetection ? 'active' : 'inactive'"
        >
          Radar Detection
        </div>
        <div
          class="pill"
          [ngClass]="tenant.visionAidedCommunications ? 'active' : 'inactive'"
        >
          Vision Aided Communications
        </div>
      </div>
    </div>
  </section>
</article>
